import { render, staticRenderFns } from "./CatalogMaterial.vue?vue&type=template&id=49b7d88d&"
import script from "./CatalogMaterial.vue?vue&type=script&lang=js&"
export * from "./CatalogMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports